"use client"

import * as React from "react"
import { Button } from "@/components/ui/button"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  React.useEffect(() => {
    console.error("Global application error:", error)
  }, [error])

  return (
    <html lang="es">
      <body className="flex min-h-screen items-center justify-center bg-background p-6 font-sans text-foreground">
        <div className="rounded-2xl border border-border bg-card p-8 shadow-sm max-w-md w-full text-center">
          <h1 className="text-xl font-bold mb-2">Error de Aplicación</h1>
          <p className="text-xs text-muted-foreground mb-6">
            {error?.message || "Se produjo un error crítico al inicializar el sistema."}
          </p>
          <Button onClick={() => reset()} className="rounded-xl font-semibold w-full bg-primary text-primary-foreground">
            Recargar Aplicación
          </Button>
        </div>
      </body>
    </html>
  )
}
